
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../app/providers/AuthProvider'
import { api } from '../lib/api'

const AuthCallback = () => {
    const [searchParams] = useSearchParams()
    const { setSession } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        const token = searchParams.get('token')

        if (token) {
            // Fetch user details given the token
            const fetchUser = async () => {
                try {
                    // Temporarily set token in local storage so api.getMe() can use it?
                    // Actually, our API client might rely on localStorage.
                    // Let's manually set it or use a helper.
                    // But wait, setSession does everything. We just need the USER object.
                    // Since we only have the token, we need to fetch 'me'.

                    localStorage.setItem('inflynx_token', token) // Hacky but effective for getMe to work if it reads from LS
                    const user = await api.getMe()
                    setSession(token, user)
                    navigate('/app', { replace: true })
                } catch (error) {
                    console.error('Failed to fetch user', error)
                    navigate('/login')
                }
            }
            fetchUser()
        } else {
            navigate('/login')
        }
    }, [searchParams, setSession, navigate])

    return (
        <div className="flex h-screen items-center justify-center bg-surface">
            <div className="text-center">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-slate-900 mx-auto"></div>
                <p className="mt-4 text-sm text-slate-500">Authenticating...</p>
            </div>
        </div>
    )
}

export default AuthCallback
